import type { PlatformFeatureType } from "@/types/graphql/partner.generated";

export function hasPlatformFeature(
  features: readonly PlatformFeatureType[] | null | undefined,
  feature: PlatformFeatureType
): boolean {
  return Boolean(features?.includes(feature));
}
